module.exports = __webpack_public_path__ + "static/media/add-icon.1e71bac7.svg";